import styled from 'styled-components'
import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-bottom: 24px;
  padding: 0 16px;
  text-align: center;

  svg {
    margin: 0 auto;
    width: 162px;
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  }

  ul {
    margin: 0 -32px;
    border-bottom: 1px solid ${({ theme }) => theme?.['-ds-neutral-300']?.value};
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    align-items: end;
    justify-content: center;
    padding: 0;
  }
`

export const NavItem = styled.li<{ active?: boolean }>`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 50%;

  button,
  a {
    display: inline-flex;
    border-bottom: 2px solid transparent;
    padding: 12px;
    color: inherit;
    font-weight: 500;
    font-size: 18px;
  }

  a {
    text-decoration: none;
  }

  ${({ theme, active }) =>
    active &&
    `
  color: ${theme?.['-ds-core-400']?.value};

  button, a {
    border-color: ${theme?.['-ds-core-400']?.value};
  }
`}
`

export const FormContainer = styled.div`
  ${media.md`
    padding: 0 16px;
  `}
`

export const Divider = styled.div`
  position: relative;
  text-align: center;
  margin: 16px 0;

  span {
    ${typeStyle('-ds-font-lead')}
    position: relative;
    background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
    color: ${({ theme }) => theme?.['-ds-neutral-500']?.value};
    padding: 8px;
  }

  &:before {
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    left: 0;
    right: 0;
    top: 49%;
    background-color: ${({ theme }) => theme?.['-ds-neutral-300']?.value};
  }
`

interface FieldWrapperProps {
  columns?: boolean
  margin?: 'medium' | 'large'
}

export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ margin }) => {
    if (margin === 'medium') return '32px'
    if (margin === 'large') return '80px'
    return '16px'
  }};
  gap: ${({ margin }) => {
    if (margin === 'medium') return '32px'
    if (margin === 'large') return '80px'
    return '16px'
  }};

  input {
    margin: 0 !important;
  }

  input:not([type='checkbox'], [type='radio']) {
    padding: 16px;
  }

  ${({ columns }) =>
    columns &&
    media.md`
    flex-direction: row;

    > div {
      flex: 1;
      width: auto;
      max-width: 100%;
      margin: 0;
    }
  `}
`
export const LoginSocial = styled.button`
  ${typeStyle('-ds-font-lead')}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  text-align: center;
  color: #1877f2;
  border: 1px solid currentColor;
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  border-radius: 8px;
  width: 100%;

  svg {
    width: 23px;
    max-height: 23px;
    margin-right: 16px;
  }
`
